import { daysInRange, isDateKey } from "./analyticsModel";
export const META_PRESETS = ["7", "28", "90", "thisMonth", "lastMonth", "custom"];
export const readMetaFilters = (params) => {
  const preset = META_PRESETS.includes(params.get("metaPreset")) ? params.get("metaPreset") : "28";
  return preset === "custom"
    ? { preset, dateFrom: params.get("metaFrom") || "", dateTo: params.get("metaTo") || "" }
    : { preset };
};
export const validMetaDates = (from, to) =>
  isDateKey(from) && isDateKey(to) && from <= to && daysInRange(from, to) <= 180;
export const metaFormat = (value, key, currency, lang) => {
  if (value === null || value === undefined || !Number.isFinite(value)) return "—";
  const locale = lang === "en" ? "en-GB" : "sq-AL";
  if (["spend", "purchaseValue", "linkCpc", "cpm", "costPerPurchase", "cost"].includes(key))
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency || "EUR",
      maximumFractionDigits: 2,
    }).format(value);
  if (key === "linkCtr")
    return new Intl.NumberFormat(locale, { style: "percent", maximumFractionDigits: 2 }).format(value);
  if (key === "purchaseRoas") return new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(value) + "×";
  return new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(value);
};
export const META_KPIS = ["spend", "impressions", "linkClicks", "linkCtr", "purchases", "purchaseRoas"];
